export const ActionTypes = {
  // contact
  FETCH_QUALITY_ASSURANCE_CONTACT: 'services/qualityAssurance/fetch_quality_assurance_contact',
  FETCH_QUALITY_ASSURANCE_CONTACT_BY_ID: 'services/qualityAssurance/fetch_quality_assurance_contact_by_id',
  SET_QUALITY_ASSURANCE_CONTACT: 'services/qualityAssurance/set_quality_assurance_contact',
  SET_QUALITY_ASSURANCE_CONTACT_LOADER_STATUS: 'services/qualityAssurance/set_quality_assurance_contact_loader_status',
  ADD_UPDATE_QUALITY_ASSURANCE_CONTACT: 'services/qualityAssurance/add_update_quality_assurance_contact',
  DELETE_QUALITY_ASSURANCE_CONTACT: 'services/qualityAssurance/delete_quality_assurance_contact',

  // complaint source
  FETCH_QUALITY_ASSURANCE_C_S: 'services/qualityAssurance/fetch_quality_assurance_c_s',
  FETCH_QUALITY_ASSURANCE_C_S_BY_ID: 'services/qualityAssurance/fetch_quality_assurance_c_s_by_id',
  SET_QUALITY_ASSURANCE_C_S: 'services/qualityAssurance/set_quality_assurance_c_s',
  SET_QUALITY_ASSURANCE_C_S_LOADER_STATUS: 'services/qualityAssurance/set_quality_assurance_c_s_loader_status',
  ADD_UPDATE_QUALITY_ASSURANCE_C_S: 'services/qualityAssurance/add_update_quality_assurance_c_s',
  DELETE_QUALITY_ASSURANCE_C_S: 'services/qualityAssurance/delete_quality_assurance_c_s',
  FETCH_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL: 'services/qualityAssurance/fetch_quality_assurance_contact_check_email',
  SET_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL: 'services/qualityAssurance/set_quality_assurance_contact_check_email',

  FETCH_QUALITY_ASSURANCE_CONTACT_ALL: 'services/qualityAssurance/fetch_quality_assurance_contact_all',
  SET_QUALITY_ASSURANCE_CONTACT_ALL: 'services/qualityAssurance/set_quality_assurance_contact_all',
};

// contact actions
const fetchQualityAssuranceContactCheckEmail = ({ qualityAssuranceContactParams }) => ({
  qualityAssuranceContactParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL,
});

const fetchQualityAssuranceContact = ({ qualityAssuranceContactParams }) => ({
  qualityAssuranceContactParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT,
});

const fetchQualityAssuranceContactById = ({ contactId }) => ({
  contactId,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_BY_ID,
});

const fetchQualityAssuranceContactAll = () => ({
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_ALL,
});

const setQualityAssuranceContactAll = ({ qualityAssuranceContactAllData }) => ({
  qualityAssuranceContactAllData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_ALL,
});

const setQualityAssuranceContact = ({ qualityAssuranceContactData }) => ({
  qualityAssuranceContactData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT,
});

const setQualityAssuranceContactCheckEmail = ({ qualityAssuranceContactCheckEmailData }) => ({
  qualityAssuranceContactCheckEmailData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL,
});

const addUpdateQualityAssuranceContact = ({
  actionName,
  qualityAssuranceContactObj,
  qualityAssuranceContactParams,
  caller,
}) => ({
  actionName,
  qualityAssuranceContactObj,
  qualityAssuranceContactParams,
  type: ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_CONTACT,
  caller,
});

const deleteQualityAssuranceContact = ({ contactId, qualityAssuranceContactParams }) => ({
  contactId,
  qualityAssuranceContactParams,
  type: ActionTypes.DELETE_QUALITY_ASSURANCE_CONTACT,
});

const setQualityAssuranceContactLoader = ({ qualityAssuranceContactLoader }) => ({
  qualityAssuranceContactLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_CONTACT_LOADER_STATUS,
});

// Complaint source
const fetchQualityAssuranceCS = ({ qualityAssuranceCSParams }) => ({
  qualityAssuranceCSParams,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_C_S,
});

const fetchQualityAssuranceCSById = ({ complaintSourceId }) => ({
  complaintSourceId,
  type: ActionTypes.FETCH_QUALITY_ASSURANCE_C_S_BY_ID,
});

const setQualityAssuranceCS = ({ qualityAssuranceCSData }) => ({
  qualityAssuranceCSData,
  type: ActionTypes.SET_QUALITY_ASSURANCE_C_S,
});

const addUpdateQualityAssuranceCS = ({ actionName, qualityAssuranceCSObj, qualityAssuranceCSParams }) => ({
  actionName,
  qualityAssuranceCSObj,
  qualityAssuranceCSParams,
  type: ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_C_S,
});

const deleteQualityAssuranceCS = ({ complaintSourceId, qualityAssuranceCSParams }) => ({
  complaintSourceId,
  qualityAssuranceCSParams,
  type: ActionTypes.DELETE_QUALITY_ASSURANCE_C_S,
});

const setQualityAssuranceCSLoader = ({ qualityAssuranceCSLoader }) => ({
  qualityAssuranceCSLoader,
  type: ActionTypes.SET_QUALITY_ASSURANCE_C_S_LOADER_STATUS,
});

export default {
  fetchQualityAssuranceContact,
  fetchQualityAssuranceContactCheckEmail,
  fetchQualityAssuranceContactById,
  setQualityAssuranceContact,
  setQualityAssuranceContactCheckEmail,
  addUpdateQualityAssuranceContact,
  deleteQualityAssuranceContact,
  setQualityAssuranceContactLoader,
  fetchQualityAssuranceCS,
  fetchQualityAssuranceCSById,
  setQualityAssuranceCS,
  addUpdateQualityAssuranceCS,
  deleteQualityAssuranceCS,
  setQualityAssuranceCSLoader,
  fetchQualityAssuranceContactAll,
  setQualityAssuranceContactAll,
};
